import { BookOpen, Plus } from "lucide-react";

import { useTran } from "@/hooks";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Can } from "@/hooks/useCan/Can";
import { useAuthStore } from "@/features/auth/hooks";
import SurveyQuestionList from "./SurveyQuestionList";

const SurveyQuestionsCard = ({
  questions,
  categories,
  isStandard,
  disabled,
  onOpenLibrary,
  onAddQuestion,
  onEditQuestion,
  onDeleteQuestion,
}) => {
  const { t } = useTran();
  const { user } = useAuthStore();
  const permissions = user?.permissions || [];
  return (
    <Card className="space-y-4 border border-border bg-card p-5 shadow-sm lg:col-span-2">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-foreground">
            {t("Questions")}
          </p>
          <p className="text-xs text-muted-foreground">
            {t("Define scored questions grouped by category.")}
          </p>
        </div>
        {!disabled ? (
          <div className="flex items-center gap-2">
            {!isStandard ? (
              <Can
                resource="surveys"
                action="view"
                userPermissions={permissions}
              >
                <Button
                  type="button"
                  variant="outline"
                  className="flex items-center gap-1"
                  onClick={onOpenLibrary}
                >
                  <BookOpen className="h-4 w-4" />
                  {t("Question Library")}
                </Button>
              </Can>
            ) : null}
            <Can
              resource="surveys"
              action="create"
              userPermissions={permissions}
            >
              <Button
                type="button"
                onClick={onAddQuestion}
                className="flex items-center gap-1"
              >
                <Plus className="h-4 w-4" />
                {t("Add Question")}
              </Button>
            </Can>
          </div>
        ) : null}
      </div>

      <SurveyQuestionList
        questions={questions}
        categories={categories}
        disabled={disabled}
        onEdit={onEditQuestion}
        onDelete={onDeleteQuestion}
      />
    </Card>
  );
};

export default SurveyQuestionsCard;
